<template>
	<fragment>
		<v-menu offset-y>
			<template v-slot:activator="{ on }">
				<tip-tap-toolbar-button v-on="on" tooltip="Add" icon="mdi-table-large-plus" :dark="dark">
				</tip-tap-toolbar-button>
			</template>
			<v-list>
				<v-list-tile @click="editor.chain().focus().addColumnBefore().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-column-plus-before</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Add column before</v-list-tile-title>
				</v-list-tile>

				<v-list-tile @click="editor.chain().focus().addColumnAfter().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-column-plus-after</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Add column after</v-list-tile-title>
				</v-list-tile>

				<v-list-tile @click="editor.chain().focus().addRowBefore().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-row-plus-before</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Add row before</v-list-tile-title>
				</v-list-tile>

				<v-list-tile @click="editor.chain().focus().addRowAfter().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-row-plus-after</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Add row after</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>

		<v-menu offset-y>
			<template v-slot:activator="{ on }">
				<tip-tap-toolbar-button v-on="on" tooltip="Delete" icon="mdi-table-large-remove" :dark="dark">
				</tip-tap-toolbar-button>
			</template>
			<v-list>
				<v-list-tile @click="editor.chain().focus().deleteColumn().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-column-remove</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Delete column</v-list-tile-title>
				</v-list-tile>

				<v-list-tile @click="editor.chain().focus().deleteRow().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-row-remove</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Delete row</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>

		<tip-tap-toolbar-button
			tooltip="Merge cells"
			icon="mdi-table-merge-cells"
			@click="editor.chain().focus().mergeCells().run()"
			:dark="dark"
		>
		</tip-tap-toolbar-button>

		<tip-tap-toolbar-button
			tooltip="Split cell"
			icon="mdi-table-split-cell"
			@click="editor.chain().focus().splitCell().run()"
			:dark="dark"
		>
		</tip-tap-toolbar-button>

		<v-menu offset-y>
			<template v-slot:activator="{ on }">
				<tip-tap-toolbar-button v-on="on" tooltip="Colors" icon="mdi-invert-colors" :dark="dark">
				</tip-tap-toolbar-button>
			</template>
			<v-list>
				<v-list-tile>
					<v-list-tile-avatar>
						<v-icon>mdi-palette</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>
						<div class="d-flex">
							<span> Change cell color </span>
							<span class="ml-2">
								<preset-input-color v-model="cellColor" default-value="#000000" @input="onCellColorChange" />
							</span>
						</div>
					</v-list-tile-title>
				</v-list-tile>

				<v-list-tile @click="editor.chain().focus().toggleHeaderRow().run()">
					<v-list-tile-avatar>
						<v-icon>mdi-table-row</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-title>Toggle header row</v-list-tile-title>
				</v-list-tile>

        <v-list-tile @click="editor.chain().focus().toggleHeaderColumn().run()">
          <v-list-tile-avatar>
            <v-icon>mdi-table-column</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Toggle column header</v-list-tile-title>
        </v-list-tile>
        
        <v-list-tile @click="editor.chain().focus().toggleHeaderCell().run()">
          <v-list-tile-avatar>
            <v-icon>mdi-table-pivot</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Toggle cell header</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

  </fragment>
</template>

<script>
import TipTapToolbarButton from 'plant-common/src/components/PRichText/TipTapToolbarButton.vue';
import { Fragment } from 'vue-fragment';
import TableSelectLength from '../../../commonInteractive/table/TableSelectLength.vue';
import PresetInputColor from '../../components/slides/styles/PresetInputColor.vue';
import { findParentNodeClosestToPos } from '@tiptap/core';

export default {
	name: 'TiptapTableButtons',
	props: ['editor', 'dark'],
	components: { PresetInputColor, TableSelectLength, TipTapToolbarButton, Fragment },
	data() {
		return {
			cellColor: null
		};
	},
	watch: {
		'editor.state.selection': {
			handler(selection) {
        this.cellColor = this.getCurrentCellBackgroundColor(selection);
			}
		}
	},
	methods: {
		insertTable(rows, cols) {
			this.editor.chain().focus().insertTable({ rows: rows, cols: cols, withHeaderRow: true }).run();
		},
		getCurrentCellBackgroundColor(selection) {
			const cellNode = findParentNodeClosestToPos(selection.$anchor, node => node.type.name === 'tableCell');

			if (cellNode?.node?.attrs?.backgroundColor) {
				return cellNode.node.attrs.backgroundColor;
			}

      const whiteTransparent = '#FFFFFF00';
			return whiteTransparent;
		},
		onCellColorChange(color) {
			if (this.editor) {
				this.editor
          .chain()
          .setCellAttribute('backgroundColor', color)
          .run();
			}
		}
	}
};
</script>
